"use client"

import { createContext, ReactNode, useState } from "react"

export interface Organization {
  id: string
  name: string
  subscription_plan: string
  subscription_billing_cycle: string
  subscription_seats: number
  subscription_active: boolean
  current_credits?: number
  total_credits?: number
  ff_public_share?: boolean
}

interface OrganizationContextProps {
  selectedOrganization: Organization | null
  setSelectedOrganization: React.Dispatch<
    React.SetStateAction<Organization | null>
  >
  reloadOrganization: boolean
  setReloadOrganization: React.Dispatch<React.SetStateAction<boolean>>
  organizationCredits: {
    current_credits: number
    total_credits: number
  }
  setOrganizationCredits: React.Dispatch<
    React.SetStateAction<{
      current_credits: number
      total_credits: number
    }>
  >
}

export const OrganizationContext = createContext<OrganizationContextProps>({
  selectedOrganization: null,
  setSelectedOrganization: () => {},
  reloadOrganization: false,
  setReloadOrganization: () => {},
  organizationCredits: {
    current_credits: 0,
    total_credits: 0,
  },
  setOrganizationCredits: () => {},
})

interface OrganizationProviderProps {
  children: ReactNode
}

export function OrganizationProvider({ children }: OrganizationProviderProps) {
  const [selectedOrganization, setSelectedOrganization] =
    useState<Organization | null>(null)

  const [reloadOrganization, setReloadOrganization] = useState(false)

  const [organizationCredits, setOrganizationCredits] = useState({
    current_credits: 0,
    total_credits: 0,
  })

  return (
    <OrganizationContext.Provider
      value={{
        selectedOrganization,
        setSelectedOrganization,
        reloadOrganization,
        setReloadOrganization,
        organizationCredits,
        setOrganizationCredits,
      }}
    >
      {children}
    </OrganizationContext.Provider>
  )
}
